import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard as freeFasAddressCard,
  faAngleRight as freeFasAngleRight,
  faBookOpen as freeFasBookOpen,
  faChevronDown as freeFasChevronDown,
  faEnvelope as freeFasEnvelope,
  faExpandAlt as freeFasExpandAlt,
  faFax as freeFasFax,
  faFileAlt as freeFasFileAlt,
  faGlobe as freeFasGlobe,
  faInfoCircle as freeFasInfoCircle,
  faMobileAlt as freeFasMobileAlt,
  faNewspaper as freeFasNewspaper,
  faPhone as freeFasPhone,
  faPlayCircle as freeFasPlayCircle,
  faSearch as freeFasSearch,
  faTimes as freeFasTimes,
  faVideo as freeFasVideo,
} from '@fortawesome/free-solid-svg-icons';

// See: https://fontawesome.com/how-to-use/on-the-web/advanced/svg-javascript-core

export function initIconLibrary() {
  library.add(
    freeFasGlobe,
    freeFasSearch,
    freeFasChevronDown,
    freeFasAngleRight,
    freeFasPlayCircle,
    freeFasEnvelope,
    freeFasFax,
    freeFasMobileAlt,
    freeFasAddressCard,
    freeFasPhone,
    freeFasFileAlt,
    freeFasInfoCircle,
    freeFasBookOpen,
    freeFasVideo,
    freeFasNewspaper,
    freeFasExpandAlt,
    freeFasTimes,
  );

  dom.watch();
}
